var els = $('.transactable-schedule-container');
if (els.length > 0) {
  require.ensure('../listings/schedule', function(require) {
    var Schedule = require('../listings/schedule');
    els.each(function() {
      return new Schedule(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/schedule.initializer.js